/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import store from 'store';
import { AxiosError, AxiosResponse } from 'axios';
import {
  GLOBAL_CONTACTS_FILTERS,
  GLOBAL_CONTACTS_FILTERS_SEARCH,
  LIST_CONTACTS_FILTERS,
  LIST_CONTACTS_FILTERS_SEARCH,
} from 'constants/types/audienceTypesNew';
import { getDesignationsServiceNew, getOrganizationsServiceNew } from 'modules/Services/AudienceServiceNew';
import { ContactsFiltersEnum, IContactsFiltersResponse, IGetGlobalContactsResponse } from '../interfaces2';

const { dispatch } = store;

export const loadGlobalOrganizationsAction = (searchTerm?: string) => {
  dispatch({
    type: searchTerm ? GLOBAL_CONTACTS_FILTERS_SEARCH.LOAD : GLOBAL_CONTACTS_FILTERS.LOAD,
    payload: { filterType: ContactsFiltersEnum.Organizations },
  });
  if (searchTerm) {
    dispatch({
      type: GLOBAL_CONTACTS_FILTERS_SEARCH.SET_SEARCH_TERM,
      payload: { filterType: ContactsFiltersEnum.Organizations, searchTerm },
    });
  }
  getOrganizationsServiceNew(undefined, searchTerm)
    .then((res: AxiosResponse<IContactsFiltersResponse>) => {
      const { data, success, message } = res.data;
      if (success && message === '' && data.length > 0) {
        const { organizations } = data[0];
        if (organizations) {
          dispatch({
            type: searchTerm ? GLOBAL_CONTACTS_FILTERS_SEARCH.SUCCESS : GLOBAL_CONTACTS_FILTERS.SUCCESS,
            payload: {
              filterType: ContactsFiltersEnum.Organizations,
              data: organizations,
            },
          });
        }
      } else {
        dispatch({
          type: searchTerm ? GLOBAL_CONTACTS_FILTERS_SEARCH.SUCCESS : GLOBAL_CONTACTS_FILTERS.SUCCESS,
          payload: {
            filterType: ContactsFiltersEnum.Organizations,
            data: [],
          },
        });
      }
    })
    .catch((err: AxiosError<IContactsFiltersResponse>) => {
      console.log('err', err);
      if (err.message !== 'Operation canceled due to new request.') {
        dispatch({
          type: searchTerm ? GLOBAL_CONTACTS_FILTERS_SEARCH.FAIL : GLOBAL_CONTACTS_FILTERS.FAIL,
          payload: { filterType: ContactsFiltersEnum.Organizations, message: err.message },
        });
      }
    });
};

export const loadGlobalDesignationsAction = (searchTerm?: string) => {
  dispatch({
    type: searchTerm ? GLOBAL_CONTACTS_FILTERS_SEARCH.LOAD : GLOBAL_CONTACTS_FILTERS.LOAD,
    payload: { filterType: ContactsFiltersEnum.Designations },
  });
  if (searchTerm) {
    dispatch({
      type: GLOBAL_CONTACTS_FILTERS_SEARCH.SET_SEARCH_TERM,
      payload: { filterType: ContactsFiltersEnum.Designations, searchTerm },
    });
  }
  getDesignationsServiceNew(undefined, searchTerm)
    .then((res: AxiosResponse<IContactsFiltersResponse>) => {
      const { data, success, message } = res.data;
      if (success && message === '' && data.length > 0) {
        const { designations } = data[0];
        if (designations) {
          dispatch({
            type: searchTerm ? GLOBAL_CONTACTS_FILTERS_SEARCH.SUCCESS : GLOBAL_CONTACTS_FILTERS.SUCCESS,
            payload: {
              filterType: ContactsFiltersEnum.Designations,
              data: designations,
            },
          });
        }
      } else {
        dispatch({
          type: searchTerm ? GLOBAL_CONTACTS_FILTERS_SEARCH.SUCCESS : GLOBAL_CONTACTS_FILTERS.SUCCESS,
          payload: {
            filterType: ContactsFiltersEnum.Designations,
            data: [],
          },
        });
      }
    })
    .catch((err: AxiosError<IGetGlobalContactsResponse>) => {
      console.log('err', err);
      if (err.message !== 'Operation canceled due to new request.') {
        dispatch({
          type: searchTerm ? GLOBAL_CONTACTS_FILTERS_SEARCH.FAIL : GLOBAL_CONTACTS_FILTERS.FAIL,
          payload: { filterType: ContactsFiltersEnum.Designations, message: err.message },
        });
      }
    });
};

export const globalContactsSelectOrganizationAction = (filter: string[], add: boolean, isSearch: boolean) => {
  dispatch({
    type: isSearch ? GLOBAL_CONTACTS_FILTERS_SEARCH.SELECT_FILTER : GLOBAL_CONTACTS_FILTERS.SELECT_FILTER,
    payload: { filter, filterType: ContactsFiltersEnum.Organizations, add },
  });
};

export const globalContactsSelectDesignationAction = (filter: string[], add: boolean, isSearch: boolean) => {
  dispatch({
    type: isSearch ? GLOBAL_CONTACTS_FILTERS_SEARCH.SELECT_FILTER : GLOBAL_CONTACTS_FILTERS.SELECT_FILTER,
    payload: { filter, filterType: ContactsFiltersEnum.Designations, add },
  });
};

export const globalContactsSelectPersonalityTypesAction = (filter: string[], add: boolean, isSearch: boolean) => {
  dispatch({
    type: isSearch ? GLOBAL_CONTACTS_FILTERS_SEARCH.SELECT_FILTER : GLOBAL_CONTACTS_FILTERS.SELECT_FILTER,
    payload: { filter, filterType: ContactsFiltersEnum.PersonalityType, add },
  });
};

export const globalContactsSelectStatusAction = (filter: string[], add: boolean, isSearch: boolean) => {
  dispatch({
    type: isSearch ? GLOBAL_CONTACTS_FILTERS_SEARCH.SELECT_FILTER : GLOBAL_CONTACTS_FILTERS.SELECT_FILTER,
    payload: { filter, filterType: ContactsFiltersEnum.Status, add },
  });
};

export const globalContactsFiltersApplyAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_FILTERS.APPLY_FILTERS });
};

export const globalContactsDesignationsResetSearchAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_FILTERS_SEARCH.RESET, payload: { filterType: ContactsFiltersEnum.Designations } });
};

export const globalContactsOrganizationsResetSearchAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_FILTERS_SEARCH.RESET, payload: { filterType: ContactsFiltersEnum.Organizations } });
};

export const globalContactsResetFilterSearchAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_FILTERS_SEARCH.RESET_SELECTION });
};

export const globalContactsResetSelectOrganizationAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_FILTERS.RESET_SELECTION, payload: { filterType: ContactsFiltersEnum.Organizations } });
};

export const globalContactsResetSelectDesignationAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_FILTERS.RESET_SELECTION, payload: { filterType: ContactsFiltersEnum.Designations } });
};

export const globalContactsResetSelectPersonalityTypeAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_FILTERS.RESET_SELECTION, payload: { filterType: ContactsFiltersEnum.PersonalityType } });
};

export const globalContactsResetSelectStatusAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_FILTERS.RESET_SELECTION, payload: { filterType: ContactsFiltersEnum.Status } });
};

export const globalContactsResetFiltersAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_FILTERS.RESET_SELECTION });
};

//* List Contacts Filters

export const setListContactsFiltersListIdAction = (listId: string) => {
  dispatch({ type: LIST_CONTACTS_FILTERS.SET_LIST_ID, payload: { listId } });
};

export const resetListContactsResetAllAction = () => {
  dispatch({ type: LIST_CONTACTS_FILTERS.RESET_ALL });
};

export const loadListOrganizationsAction = (listId?: string, searchTerm?: string) => {
  dispatch({
    type: searchTerm ? LIST_CONTACTS_FILTERS_SEARCH.LOAD : LIST_CONTACTS_FILTERS.LOAD,
    payload: { filterType: ContactsFiltersEnum.Organizations },
  });
  if (searchTerm) {
    dispatch({
      type: LIST_CONTACTS_FILTERS_SEARCH.SET_SEARCH_TERM,
      payload: { filterType: ContactsFiltersEnum.Organizations, searchTerm },
    });
  }
  getOrganizationsServiceNew(listId, searchTerm)
    .then((res: AxiosResponse<IContactsFiltersResponse>) => {
      console.log('res', res);
      console.log('res.data', res.data.data);

      const { data, success, message } = res.data;
      if (success && message === '' && data.length > 0) {
        const { organizations } = data[0];
        if (organizations) {
          dispatch({
            type: searchTerm ? LIST_CONTACTS_FILTERS_SEARCH.SUCCESS : LIST_CONTACTS_FILTERS.SUCCESS,
            payload: {
              filterType: ContactsFiltersEnum.Organizations,
              data: organizations,
            },
          });
        }
      } else {
        dispatch({
          type: searchTerm ? LIST_CONTACTS_FILTERS_SEARCH.SUCCESS : LIST_CONTACTS_FILTERS.SUCCESS,
          payload: {
            filterType: ContactsFiltersEnum.Organizations,
            data: [],
          },
        });
      }
    })
    .catch((err: AxiosError<IContactsFiltersResponse>) => {
      console.log('err', err);
      if (err.message !== 'Operation canceled due to new request.') {
        dispatch({
          type: searchTerm ? LIST_CONTACTS_FILTERS_SEARCH.FAIL : LIST_CONTACTS_FILTERS.FAIL,
          payload: { filterType: ContactsFiltersEnum.Organizations, message: err.message },
        });
      }
    });
};

export const loadListDesignationsAction = (listId?: string, searchTerm?: string) => {
  dispatch({
    type: searchTerm ? LIST_CONTACTS_FILTERS_SEARCH.LOAD : LIST_CONTACTS_FILTERS.LOAD,
    payload: { filterType: ContactsFiltersEnum.Designations },
  });

  if (searchTerm) {
    dispatch({
      type: LIST_CONTACTS_FILTERS_SEARCH.SET_SEARCH_TERM,
      payload: { filterType: ContactsFiltersEnum.Designations, searchTerm },
    });
  }

  getDesignationsServiceNew(listId, searchTerm)
    .then((res: AxiosResponse<IContactsFiltersResponse>) => {
      console.log('res', res);
      console.log('res.data', res.data.data);

      const { data, success, message } = res.data;
      if (success && message === '' && data.length > 0) {
        const { designations } = data[0];
        if (designations) {
          dispatch({
            type: searchTerm ? LIST_CONTACTS_FILTERS_SEARCH.SUCCESS : LIST_CONTACTS_FILTERS.SUCCESS,
            payload: {
              filterType: ContactsFiltersEnum.Designations,
              data: designations,
            },
          });
        }
      } else {
        dispatch({
          type: searchTerm ? LIST_CONTACTS_FILTERS_SEARCH.SUCCESS : LIST_CONTACTS_FILTERS.SUCCESS,
          payload: {
            filterType: ContactsFiltersEnum.Designations,
            data: [],
          },
        });
      }
    })
    .catch((err: AxiosError<IGetGlobalContactsResponse>) => {
      console.log('err', err);
      if (err.message !== 'Operation canceled due to new request.') {
        dispatch({
          type: searchTerm ? LIST_CONTACTS_FILTERS_SEARCH.FAIL : LIST_CONTACTS_FILTERS.FAIL,
          payload: { filterType: ContactsFiltersEnum.Designations, message: err.message },
        });
      }
    });
};

export const listContactsSelectOrganizationAction = (filter: string[], add: boolean, isSearch: boolean) => {
  dispatch({
    type: isSearch ? LIST_CONTACTS_FILTERS_SEARCH.SELECT_FILTER : LIST_CONTACTS_FILTERS.SELECT_FILTER,
    payload: { filter, filterType: ContactsFiltersEnum.Organizations, add },
  });
};

export const listContactsSelectDesignationAction = (filter: string[], add: boolean, isSearch: boolean) => {
  dispatch({
    type: isSearch ? LIST_CONTACTS_FILTERS_SEARCH.SELECT_FILTER : LIST_CONTACTS_FILTERS.SELECT_FILTER,
    payload: { filter, filterType: ContactsFiltersEnum.Designations, add },
  });
};

export const listContactsSelectPersonalityTypeAction = (filter: string[], add: boolean, isSearch: boolean) => {
  dispatch({
    type: isSearch ? LIST_CONTACTS_FILTERS_SEARCH.SELECT_FILTER : LIST_CONTACTS_FILTERS.SELECT_FILTER,
    payload: { filter, filterType: ContactsFiltersEnum.PersonalityType, add },
  });
};

export const listContactsSelectStatusAction = (filter: string[], add: boolean, isSearch: boolean) => {
  dispatch({
    type: isSearch ? LIST_CONTACTS_FILTERS_SEARCH.SELECT_FILTER : LIST_CONTACTS_FILTERS.SELECT_FILTER,
    payload: { filter, filterType: ContactsFiltersEnum.Status, add },
  });
};

export const listContactsFiltersApplyAction = () => {
  dispatch({ type: LIST_CONTACTS_FILTERS.APPLY_FILTERS });
};

export const listContactsResetFiltersAction = () => {
  dispatch({ type: LIST_CONTACTS_FILTERS.RESET_SELECTION });
};

export const listContactsDesignationsResetSearchAction = () => {
  dispatch({ type: LIST_CONTACTS_FILTERS_SEARCH.RESET, payload: { filterType: ContactsFiltersEnum.Designations } });
};

export const listContactsOrganizationsResetSearchAction = () => {
  dispatch({ type: LIST_CONTACTS_FILTERS_SEARCH.RESET, payload: { filterType: ContactsFiltersEnum.Organizations } });
};

export const listContactsResetFilterSearchAction = () => {
  dispatch({ type: LIST_CONTACTS_FILTERS_SEARCH.RESET_SELECTION });
};
